// window.__KP_RUM_CONFIG__ に Rails が注入した設定値を正規化するモジュール。
// 設定が不完全・不正な場合は enabled: false のデフォルト設定を返すことで fail-closed を実現する。

// 必須キーが欠落した際のフォールバック値（常に enabled: false）
const DEFAULT_CONFIG = {
  enabled: false,
  applicationId: null,
  clientToken: null,
  site: null,
  service: null,
  env: null,
  sessionSampleRate: 20,       // サンプリング率デフォルト: 20%
  sessionReplaySampleRate: 0,  // セッションリプレイはデフォルト無効
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "mask-user-input",  // 入力値は常にマスク
};

const normalizeBoolean = (value, fallback) => {
  if (typeof value === "boolean") {
    return value;
  }
  return fallback;
};

const normalizeRate = (value, fallback) => {
  if (typeof value !== "number" || Number.isNaN(value)) {
    return fallback;
  }

  if (value < 0 || value > 100) {
    return fallback;
  }

  return value;
};

const normalizeString = (value) => {
  if (typeof value !== "string") {
    return null;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

// window.__KP_RUM_CONFIG__ の生の値を受け取り、型・範囲・必須キーを検証して正規化した設定を返す。
// 以下のいずれかに該当する場合は DEFAULT_CONFIG（enabled: false）を返す:
//   - enabled が false/未設定
//   - applicationId / clientToken / site / service / env のいずれかが欠落
export const normalizeRumConfig = (raw) => {
  const candidate = raw ?? {};

  const normalized = {
    enabled: normalizeBoolean(candidate.enabled, false),
    applicationId: normalizeString(candidate.applicationId),
    clientToken: normalizeString(candidate.clientToken),
    site: normalizeString(candidate.site),
    service: normalizeString(candidate.service),
    env: normalizeString(candidate.env),
    version: normalizeString(candidate.version) ?? undefined,
    sessionSampleRate: normalizeRate(candidate.sessionSampleRate, DEFAULT_CONFIG.sessionSampleRate),
    sessionReplaySampleRate: normalizeRate(candidate.sessionReplaySampleRate, DEFAULT_CONFIG.sessionReplaySampleRate),
    trackUserInteractions: normalizeBoolean(candidate.trackUserInteractions, DEFAULT_CONFIG.trackUserInteractions),
    trackResources: normalizeBoolean(candidate.trackResources, DEFAULT_CONFIG.trackResources),
    trackLongTasks: normalizeBoolean(candidate.trackLongTasks, DEFAULT_CONFIG.trackLongTasks),
    defaultPrivacyLevel: "mask-user-input",
  };

  // フラグが無効の場合はデフォルト（無効）を返す
  if (!normalized.enabled) {
    return { ...DEFAULT_CONFIG };
  }

  // 必須キーが1つでも欠落していれば初期化できないため無効扱いにする
  if (!normalized.applicationId || !normalized.clientToken || !normalized.site || !normalized.service || !normalized.env) {
    return { ...DEFAULT_CONFIG };
  }

  return normalized;
};
